declare module "@mui/material/styles/createPalette" {
  interface Palette {
    light01?: string;
    light02?: string;
    content?: string;
    result?: string;
    neutral?: Palette["primary"];
  }

  interface PaletteOptions {
    neutral?: PaletteOptions["primary"];
  }
  interface PaletteColor {
    light01?: string;
    light02?: string;
    content?: string;
    result?: string;
  }

  interface SimplePaletteColorOptions {
    light01?: string;
    light02?: string;
    content?: string;
    result?: string;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    standard: true;
    rest: true;
  }
}

declare module "@mui/material" {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
  interface ChipPropsColorOverrides {
    neutral: true;
  }
}

declare module "@mui/material/styles" {
  interface TypographyVariants {
    body3: React.CSSProperties;
    subtitle3: React.CSSProperties;
    helper: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    body3?: React.CSSProperties;
    subtitle3: React.CSSProperties;
    helper: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    body3: true;
    subtitle3: true;
    helper: true;
  }
}

// SETUP COLORS
const PRIMARY = {
  main: "#1F7B44",
  light01: "#4B9752",
  light02: "#A5CB97",
  background: "#F2F9EF",
};
const SECONDARY = {
  main: "#4B9752",
};
const INFO = {
  main: "#4697E9",
};
const SUCCESS = {
  main: "#4CAF50",
};
const WARNING = {
  main: "#F4B000",
  light01: "#F9CF64",
  light02: "#FFF7E2",
  result: "#FFEDBF",
};
const ERROR = {
  main: "#D91212",
  light01: "#E34848",
  light02: "#FFE9E9",
  content: "#8E251E",
};
const NEUTRAL = {
  main: "#707070",
};

const COMMON = {
  common: { black: "#000", white: "#fff" },
  primary: { ...PRIMARY, contrastText: "#FFFFFF" },
  secondary: { ...SECONDARY, contrastText: "#F7F7F7" },
  info: { ...INFO, contrastText: "#fff" },
  success: { ...SUCCESS, contrastText: "#fff" },
  warning: { ...WARNING, contrastText: "#fff" },
  error: { ...ERROR, contrastText: "#fff" },
  neutral: {
    ...NEUTRAL,
    contrastText: "#fff",
  },
  divider: "#0000001F",
  action: {
    active: "#0000008A",
    hover: "#0000000A",
    selected: "#00000014",
    disabled: "#909090",
    disabledBackground: "#EAEAEA",
    focus: "#0000001F",
  },
};

const palette = {
  ...COMMON,
  mode: "light",
  text: { primary: "#000000DE", secondary: "#707070", disabled: "#00000061" },
} as const;

export default palette;
